import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { NavSeparator } from 'src/app/shared/types/NavItem.type';

@Component({
    selector: 'app-nav-list-separator',
    imports: [
        // Angular
        // Angular Material
        MatDividerModule,
        // Own
    ],
    templateUrl: './nav-list-separator.component.html',
    styleUrl: './nav-list-separator.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavListSeparatorComponent {
    public separator = input.required<NavSeparator>();
}
